import VueRouter, { RouteConfig } from "vue-router";
import { Routes } from "../enums/routes.enum";
import { MazeedRoutes } from "@/enums/mazeed/mazeed.routes";
import store from "./../store";
import { PermissionsSlugs } from "@/enums/permissions.enum";
import { ToolsRoutes } from "@/enums/tools/tools.routes";

const routes: Array<RouteConfig> = [
  { path: "/", redirect: Routes.users },
  {
    path: "/" + Routes.users,
    component: () => import("@/views/users/UserList.vue"),
    name: Routes.users,
  },
  {
    path: "/" + Routes.userDetails,
    component: () => import("@/views/users/UserDetails.vue"),
    name: Routes.userDetails,
  },
  {
    path: "/" + Routes.userCreate,
    component: () => import("@/views/users/UserCreate.vue"),
    name: Routes.userCreate,
  },
  {
    path: "/" + Routes.roles,
    component: () => import("@/views/roles/RoleList.vue"),
    name: Routes.roles,
  },
  {
    path: "/" + Routes.roleDetails,
    component: () => import("@/views/roles/RoleDetails.vue"),
    name: Routes.roleDetails,
  },
  {
    path: "/" + Routes.roleCreate,
    component: () => import("@/views/roles/RoleCreate.vue"),
    name: Routes.roleCreate,
  },
  {
    path: "/" + Routes.merchants,
    component: () => import("@/views/merchants/MerchantsList.vue"),
    name: Routes.merchants,
  },
  {
    path: "/" + Routes.merchantDetails,
    component: () => import("@/views/merchants/MerchantDetails.vue"),
    name: Routes.merchantDetails,
  },
  {
    path: "/" + Routes.merchantPurchaseDetails,
    component: () => import("@/views/merchants/MerchantPurchaseDetails.vue"),
    name: Routes.merchantPurchaseDetails,
  },
  {
    path: "/" + Routes.login,
    name: Routes.login,
    component: () => import("@/views/Auth/SignIn.vue"),
  },
  {
    path: "/" + Routes.purchases,
    name: Routes.purchases,
    component: () => import("@/views/purchases/PurchasesList.vue"),
  },
  {
    path: "/" + Routes.products,
    name: Routes.products,
    meta: {
      permissions: [PermissionsSlugs.canViewProducts],
    },
    component: () => import("@/views/products/ProductsList.vue"),
  },
  {
    path: "/" + Routes.productsDetails,
    name: Routes.productsDetails,
    meta: {
      permissions: [PermissionsSlugs.canViewProducts],
    },
    component: () => import("@/views/products/ProductsDetails.vue"),
  },
  {
    path: "/" + Routes.purchaseCreate,
    name: Routes.purchaseCreate,
    component: () => import("@/views/purchases/PurchaseCreate.vue"),
  },
  {
    path: "/" + Routes.enterprisePurchaseCreate,
    name: Routes.enterprisePurchaseCreate,
    component: () => import("@/views/purchases/PurchaseCreateEnterprise.vue"),
  },
  {
    path: "/" + Routes.offers,
    name: Routes.offers,
    component: () => import("@/views/offers/offers.vue"),
  },
  {
    path: "/" + Routes.coupons,
    name: Routes.coupons,
    component: () => import("@/views/offers/offers.vue"),
  },
  {
    path: "/" + Routes.offersCreateAndDetails + "/:id?",
    name: Routes.offersCreateAndDetails,
    component: () => import("@/views/offers/offersCreateAndDetails.vue"),
  },
  {
    path: "/" + Routes.packageDetails,
    name: Routes.packageDetails,
    component: () => import("@/views/packages/packagesDetails.vue"),
  },
  {
    path: "/" + Routes.countries,
    name: Routes.countries,
    component: () => import("@/views/countries/Countries.vue"),
  },
  {
    path: "/" + Routes.zidWallet,
    name: Routes.zidWallet,
    component: () => import("@/views/zidWallet/ZidWallet.vue"),
  },
  {
    path: "/" + Routes.walletVerificationDetails,
    name: Routes.walletVerificationDetails,
    component: () => import("@/views/zidWallet/VerificationRequestDetails.vue"),
  },
  {
    path: "/" + Routes.packages,
    name: Routes.packages,
    component: () => import("@/views/packages/packages.vue"),
  },
  {
    path: "/" + Routes.themes,
    name: Routes.themes,
    component: () => import("@/views/themes/Themes.vue"),
  },
  {
    path: "/" + Routes.sms,
    name: Routes.sms,
    meta: {
      anyPermissions: [
        PermissionsSlugs.canViewSmsProviderSettings,
        PermissionsSlugs.canManageSmsProviderSettings,
        PermissionsSlugs.canManageLegacySmsProviderSettings,
      ],
    },
    component: () => import("@/views/sms/SmsProviderTools.vue"),
  },
  {
    path: "/" + Routes.campaignSenders,
    name: Routes.campaignSenders,
    component: () => import("@/views/sms/SmsSenders.vue"),
  },
  {
    path: "/" + Routes.dashboard,
    name: Routes.dashboard,
    component: () => import("@/views/dashboard/Dashboard.vue"),
  },
  {
    path: "/" + Routes.log,
    name: Routes.log,
    component: () => import("@/views/log/log.vue"),
  },
  {
    path: "/" + Routes.merchantOrderDetails,
    name: Routes.merchantOrderDetails,
    component: () => import("@/views/merchants/MerchantOrderDetails.vue"),
  },
  {
    path: "/" + Routes.marketplace,
    name: Routes.marketplace,
    component: () => import("@/views/marketplace/Marketplace.vue"),
  },
  {
    path: "/" + Routes.latestFeatures,
    name: Routes.latestFeatures,
    component: () => import("@/views/latestFeatures/LatestFeatures.vue"),
  },
  {
    path: "/" + Routes.contracts,
    name: Routes.contracts,
    component: () => import("@/views/contracts/contracts.vue"),
  },
  {
    path: "/" + Routes.paymentLinks,
    name: Routes.paymentLinks,
    component: () => import("@/views/paymentLinks/paymentLinks.vue"),
  },
  {
    path: "/" + Routes.paymentLinksCreate,
    name: Routes.paymentLinksCreate,
    component: () => import("@/views/paymentLinks/PaymentLinkCreate.vue"),
  },
  {
    path: "/" + Routes.paymentLinksDetails,
    name: Routes.paymentLinksDetails,
    component: () => import("@/views/paymentLinks/PaymentLinkDetails.vue"),
  },
  {
    path: "/" + Routes.oneTimeOffersList,
    name: Routes.oneTimeOffersList,
    component: () => import("@/views/oneTimeOffers/oneTimeOffers.vue"),
  },
  {
    path: "/" + Routes.oneTimeOffersEdit,
    name: Routes.oneTimeOffersEdit,
    component: () => import("@/views/oneTimeOffers/oneTimeOffersEdit.vue"),
  },
  {
    path: "/" + Routes.mazeed,
    name: Routes.mazeed,
    component: () => import("@/views/mazeed/mazeed.vue"),
    children: [
      {
        path: MazeedRoutes.customersBase,
        name: MazeedRoutes.customersBase,
        component: () => import("@/views/mazeed/customers/index.vue"),
        redirect: (to) => {
          return { path: MazeedRoutes.customersList };
        },
        children: [
          {
            path: MazeedRoutes.customersList,
            name: MazeedRoutes.customersList,
            meta: {
              permissions: [PermissionsSlugs.canViewCustomers],
            },
            component: () =>
              import("@/views/mazeed/customers/CustomersList.vue"),
          },
          {
            path: MazeedRoutes.customersDetails,
            name: MazeedRoutes.customersDetails,
            meta: {
              permissions: [PermissionsSlugs.canViewCustomers],
            },
            component: () =>
              import("@/views/mazeed/customers/CustomerDetails.vue"),
          },
        ],
      },
      {
        path: MazeedRoutes.categoriesBase,
        name: MazeedRoutes.categoriesBase,
        component: () => import("@/views/mazeed/categories/CategoriesBase.vue"),
        redirect: MazeedRoutes.categoriesList,
        children: [
          {
            path: MazeedRoutes.categoriesList,
            name: MazeedRoutes.categoriesList,
            meta: {
              permissions: [PermissionsSlugs.canViewMazeedCategories],
            },
            component: () => import("@/views/mazeed/categories/Categories.vue"),
          },
          {
            path: MazeedRoutes.categoriesCreate,
            name: MazeedRoutes.categoriesCreate,
            component: () =>
              import("@/views/mazeed/categories/CategoryCreate.vue"),
          },
          {
            path: MazeedRoutes.categoriesDetails,
            name: MazeedRoutes.categoriesDetails,
            meta: {
              permissions: [PermissionsSlugs.canViewMazeedCategoryDetails],
            },
            component: () =>
              import("@/views/mazeed/categories/CategoryDetails.vue"),
          },
        ],
      },
      {
        path: MazeedRoutes.productsBase,
        name: MazeedRoutes.productsBase,
        component: () => import("@/views/mazeed/products/index.vue"),
        redirect: MazeedRoutes.productsList,
        children: [
          {
            path: MazeedRoutes.productsList,
            name: MazeedRoutes.productsList,
            component: () => import("@/views/mazeed/products/Products.vue"),
          },
          {
            path: MazeedRoutes.productDetails,
            name: MazeedRoutes.productDetails,
            component: () =>
              import("@/views/mazeed/products/ProductDetails.vue"),
          },
        ],
      },
      {
        path: MazeedRoutes.settlementsBase,
        name: MazeedRoutes.settlementsBase,
        component: () =>
          import("@/views/mazeed/settlements/SettlementsBase.vue"),
        redirect: MazeedRoutes.settlementsList,
        children: [
          {
            path: MazeedRoutes.settlementsList,
            name: MazeedRoutes.settlementsList,
            meta: {
              permissions: [PermissionsSlugs.canViewMazeedSettlements],
            },
            component: () =>
              import("@/views/mazeed/settlements/Settlements.vue"),
          },
          {
            path: MazeedRoutes.settlementDetails,
            name: MazeedRoutes.settlementDetails,
            meta: {
              permissions: [PermissionsSlugs.canViewMazeedSettlements],
            },
            component: () =>
              import("@/views/mazeed/settlements/SettlementsDetails.vue"),
          },
        ],
      },
      {
        path: MazeedRoutes.stores,
        component: () => import("@/views/mazeed/index.vue"),
        children: [
          {
            path: MazeedRoutes.storesList,
            name: MazeedRoutes.storesList,
            meta: {
              permissions: [PermissionsSlugs.canViewMazeedStores],
            },
            component: () => import("@/views/mazeed/stores/StoresList.vue"),
          },
          {
            path: MazeedRoutes.storeDetails,
            name: MazeedRoutes.storeDetails,
            meta: {
              permissions: [PermissionsSlugs.canViewMazeedStoreDetails],
            },
            component: () => import("@/views/mazeed/stores/StoreDetails.vue"),
          },
          {
            path: MazeedRoutes.createStore,
            name: MazeedRoutes.createStore,
            component: () => import("@/views/mazeed/stores/CreateStore.vue"),
          },
        ],
      },
      {
        path: MazeedRoutes.banners,
        component: () => import("@/views/mazeed/banners/Banners.vue"),
        redirect: `${MazeedRoutes.banners}/${MazeedRoutes.bannersList}`,
        children: [
          {
            path: MazeedRoutes.bannersList,
            name: MazeedRoutes.bannersList,
            meta: {
              permissions: [PermissionsSlugs.canViewMazeedBanners],
            },
            component: () => import("@/views/mazeed/banners/BannersList.vue"),
          },
          {
            path: MazeedRoutes.bannersDetails,
            name: MazeedRoutes.bannersDetails,
            meta: {
              permissions: [PermissionsSlugs.canViewMazeedBanners],
            },
            component: () => import("@/views/mazeed/banners/BannerDetails.vue"),
          },
          {
            path: MazeedRoutes.bannersEdit,
            name: MazeedRoutes.bannersEdit,
            meta: {
              permissions: [PermissionsSlugs.canEditMazeedBanners],
            },
            component: () => import("@/views/mazeed/banners/EditBanner.vue"),
          },
          {
            path: MazeedRoutes.bannerCreate,
            name: MazeedRoutes.bannerCreate,
            meta: {
              permissions: [PermissionsSlugs.canCreateMazeedBanners],
            },
            component: () => import("@/views/mazeed/banners/CreateBanner.vue"),
          },
        ],
      },
      {
        path: MazeedRoutes.ordersBase,
        component: () => import("@/views/mazeed/index.vue"),
        redirect: `${MazeedRoutes.ordersBase}/${MazeedRoutes.ordersList}`,
        children: [
          {
            path: MazeedRoutes.ordersList,
            name: MazeedRoutes.ordersList,
            meta: {
              permissions: [PermissionsSlugs.canViewMazeedOrders],
            },
            component: () => import("@/views/mazeed/orders/OrdersList.vue"),
          },
          {
            path: MazeedRoutes.orderDetails,
            name: MazeedRoutes.orderDetails,
            meta: {
              permissions: [PermissionsSlugs.canViewMazeedOrderDetails],
            },
            component: () => import("@/views/mazeed/orders/OrderDetails.vue"),
          },
          {
            path: MazeedRoutes.orderDetailsNew,
            name: MazeedRoutes.orderDetailsNew,
            meta: {
              permissions: [PermissionsSlugs.canViewMazeedOrderDetails],
            },
            component: () =>
              import("@/views/mazeed/orders/OrderDetailsPlus.vue"),
          },
          {
            path: MazeedRoutes.orderInvoice,
            name: MazeedRoutes.orderInvoice,
            meta: {
              permissions: [PermissionsSlugs.canViewMazeedOrders],
            },
            component: () => import("@/views/mazeed/orders/OrderInvoice.vue"),
          },
        ],
      },
      {
        path: MazeedRoutes.discover,
        component: () => import("@/views/mazeed/discover/Discover.vue"),
        redirect: MazeedRoutes.discoverCollectionListing,
        children: [
          {
            path: MazeedRoutes.discoverCollectionListing,
            name: MazeedRoutes.discoverCollectionListing,
            component: () =>
              import(
                "@/views/mazeed/discover/Listing/Collections/CollectionsList.vue"
              ),
          },
          {
            path: MazeedRoutes.discoverSectionListing,
            name: MazeedRoutes.discoverSectionListing,
            component: () =>
              import(
                "@/views/mazeed/discover/Listing/Sections/SectionsList.vue"
              ),
          },
          {
            path: MazeedRoutes.discoverItems,
            name: MazeedRoutes.discoverItems,
            component: () =>
              import(
                "@/views/mazeed/discover/CreateEditItems/CreateEditItems.vue"
              ),
          },
        ],
      },
      {
        path: MazeedRoutes.couponsBase,
        name: MazeedRoutes.couponsBase,
        component: () => import("@/views/mazeed/coupons/Coupons.vue"),
        redirect: `${MazeedRoutes.couponsBase}/${MazeedRoutes.couponsList}`,
        children: [
          {
            path: MazeedRoutes.couponsList,
            name: MazeedRoutes.couponsList,
            meta: {
              permissions: [PermissionsSlugs.canViewMazeedCoupons],
            },
            component: () => import("@/views/mazeed/coupons/CouponsList.vue"),
          },
          {
            path: MazeedRoutes.couponsDetails,
            name: MazeedRoutes.couponsDetails,
            meta: {
              permissions: [PermissionsSlugs.canViewMazeedCoupons],
            },
            component: () => import("@/views/mazeed/coupons/CouponDetails.vue"),
          },
          {
            path: MazeedRoutes.couponsCreate,
            name: MazeedRoutes.couponsCreate,
            meta: {
              permissions: [PermissionsSlugs.canCreateMazeedCoupon],
            },
            component: () => import("@/views/mazeed/coupons/CreateCoupon.vue"),
          },
        ],
      },
      {
        path: MazeedRoutes.tagsBase,
        name: MazeedRoutes.tagsBase,
        component: () => import("@/views/mazeed/tags/index.vue"),
        redirect: (to) => {
          return { path: MazeedRoutes.tagsList };
        },
        children: [
          {
            path: MazeedRoutes.tagsList,
            name: MazeedRoutes.tagsList,
            component: () => import("@/views/mazeed/tags/TagsList.vue"),
          },
          {
            path: MazeedRoutes.tagsCreate,
            name: MazeedRoutes.tagsCreate,
            component: () => import("@/views/mazeed/tags/TagCreate.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/" + Routes.tools,
    name: Routes.tools,
    component: () => import("@/views/tools/tools.vue"),
    children: [
      {
        path: ToolsRoutes.zam,
        name: ToolsRoutes.zam,
        meta: {
          permissions: [PermissionsSlugs.canUseZamTools],
        },
        component: () => import("@/views/tools/ZamTools.vue"),
      },
      {
        path: ToolsRoutes.switchers,
        name: ToolsRoutes.switchers,
        meta: {
          permissions: [PermissionsSlugs.canUseSwitcherTools],
        },
        component: () => import("@/views/tools/SwitcherTools.vue"),
      },
      {
        path: ToolsRoutes.subscriptions,
        name: ToolsRoutes.subscriptions,
        meta: {
          permissions: [PermissionsSlugs.canUseSubscriptionTools],
        },
        component: () => import("@/views/tools/SubscriptionTools.vue"),
      },
      {
        path: ToolsRoutes.eraseCustomer,
        name: ToolsRoutes.eraseCustomer,
        meta: {
          permissions: [PermissionsSlugs.canEraseCustomer],
        },
        component: () => import("@/views/tools/EraseCustomer.vue"),
      },
    ],
  },
  {
    path: Routes.forbidden,
    name: Routes.forbidden,
    component: () => import("@/views/errors/403.vue"),
  },
  {
    path: "*",
    component: () => import("@/views/errors/404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated;
  if (to.name == Routes.login) return next();
  if (isAuthenticated) {
    if (
      to.name == Routes.userCreate &&
      !store.getters.havePermission(PermissionsSlugs.canCreateUsers)
    )
      return next({ name: Routes.forbidden });
    if (
      to.name == Routes.users &&
      !store.getters.havePermission(PermissionsSlugs.canViewUsers)
    )
      return next({ name: Routes.forbidden });
    if (
      to.name == Routes.roleCreate &&
      !store.getters.havePermission(PermissionsSlugs.canCreateRoles)
    )
      return next({ name: Routes.forbidden });
    if (
      to.name == Routes.roles &&
      !store.getters.havePermission(PermissionsSlugs.canViewRoles)
    )
      return next({ name: Routes.forbidden });
    if (
      to.name == Routes.merchants &&
      !store.getters.havePermission(PermissionsSlugs.canViewMerchants)
    )
      return next({ name: Routes.forbidden });
    if (
      to.name == Routes.purchases &&
      !store.getters.havePermission(
        PermissionsSlugs.canViewPendingPurchasesAsCS
      ) &&
      !store.getters.havePermission(
        PermissionsSlugs.canViewPendingPurchasesAsFinance
      )
    )
      return next({ name: Routes.forbidden });
    // NOTE: This is a generic permission that can be used in any route
    if (
      to.meta?.anyPermissions &&
      !to.meta.anyPermissions.some((permission: PermissionsSlugs) =>
        store.getters.havePermission(permission)
      )
    ) {
      return next({ name: Routes.forbidden });
    }
    if (
      to.meta?.permissions &&
      !store.getters.havePermissions(to.meta.permissions)
    ) {
      return next({ name: Routes.forbidden });
    }
    next();
  } else {
    store.dispatch("removeUser");
    next({ name: Routes.login });
  }
});

export default router;
